import { IconDefaultType as IconType } from "@slhuiicon/icon";

export const SWITCH_ICON_WIDTH: string = "32";
export const SWITCH_ICON_HEIGHT: string = "24";
export const SWITCH_ICON_ON: IconType = IconType.ICO_SWITCH_ON;
export const SWITCH_ICON_OFF: IconType = IconType.ICO_SWITCH_OFF;
